//import Vue from "vue";

interface ConfirmItem {
  orderItemId: number;
  saleVolume: number;
}

interface Order {
  confirmItems?: Array<ConfirmItem>;
  duplicateInvoice?: boolean;
  taxId?: string;
  telephone?: string;
  note?: string;
  email?: string;
  address?: string;
  company?: string;
  recipient?: string;
  managerId?: number;
}

const getDefaultOrder = () => {
  return {
    confirmItems: [],
    duplicateInvoice: true,
    taxId: "",
    telephone: "",
    note: "",
    email: "",
    address: "",
    company: "",
    recipient: "",
    managerId: 0
  } as Order;
};
const newOrder = {
  namespaced: true,
  state: {
    confirmItems: [],
    duplicateInvoice: true,
    taxId: "",
    telephone: "",
    note: "",
    email: "",
    address: "",
    company: "",
    recipient: "",
    managerId: 0
  } as Order,
  mutations: {
    setConfirmItem(state: Order, options: Array<ConfirmItem>) {
      state.confirmItems = options;
    },
    setInfo(state: Order, options: Order) {
      state.address = options.address;
      state.company = options.company;
      state.email = options.email;
      state.note = options.note;
      state.taxId = options.taxId;
      state.recipient = options.recipient;
      state.telephone = options.telephone;
      state.duplicateInvoice = options.duplicateInvoice;
      state.managerId = options.managerId;
    },
    clearOrder(state: Order) {
      Object.assign(state, getDefaultOrder());
    }
  },
  actions: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async getCart(context: any) {
      console.log(context);
    }
  }
};

export default newOrder;
